// extracted by mini-css-extract-plugin
export default {"container":"TableofContent_container__W8O+V","video":"TableofContent_video__IrGwD"};